import inViewport from '@resources/js/helpers/inViewport'
import MapView from '@resources/js/maps/MapView'
import locationListsToggle from '@resources/js/locationListsToggle'


inViewport("#mapbox", () => {
    const map = new MapView()
    map.addMainMarker()
})

locationListsToggle()
